<template>
  <div class="highlighted-card">
    <!-- @slot Here comes the content of the card -->
    <slot></slot>
  </div>
</template>

<script>
/**
 * This gives a styled card having active background
 */
export default {
  name: 'HighlightedCard'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.highlighted-card {
  padding: 14px 18px;
  background: $activeQuaternary;
  box-shadow: 0px 1px 3px $tertiary;
  border-radius: 5px;
}
</style>
